import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Box, Dialog, DialogContent, DialogTitle, Grid, IconButton, InputAdornment, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState, useMemo } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import customPlanIcon from "../../../asset/image/CustomPlanIcon.svg";
import starlinkPlanIcon from "../../../asset/image/StarlinkPlanIcon.svg";
import orgPoolIcon from "../../../asset/image/OrgPoolIcon.svg";
import _ from "lodash";
import CloseIcon from '@mui/icons-material/Close';
import planFilterButton from "../../../asset/image/planFilterButton.svg";
import SearchIcon from "@mui/icons-material/Search";
import { getServiceLinePerPlan } from "../../StarlinkPooled/slice";
import { useAuthorization } from "../../../utils/util";

const PlanHeirarchy = (props) => {
    const { serviceLinePlans, selectedOu, setParentPoolId, setPlanFilter, setSelectedRow, setExpandedRows, selectedRow, expandedRows, planData, expand, getServiceLinePerPlan } = props;

    
    const [searchValue, setSearchValue] = useState("");
    const [selectedPlan, setSelectedPlan] = useState<any>({});
    const [servicePlansLocal, setServicePlansLocal] = useState<any>([]);
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState("");
    const [options, setOptions] = useState<any>([]);
    const [switchServiceLineToggle, setSwitchServiceLineToggle] = useState(false)
    const { isAdmin } = useAuthorization();

    const handleExpandClick = (id, poolId, row) => {
        setExpandedRows((prevExpandedRows) => {
            const isCurrentlyExpanded = prevExpandedRows[id] ?? false;
            let newExpandedRows = { ...prevExpandedRows };

            if (isCurrentlyExpanded) {
                // Collapse clicked row
                delete newExpandedRows[id];
            } else {
                // Expand clicked row
                if (row.account_type === "pooled" || row.account_type === "standard") {
                    // Collapse all other top-level rows
                    newExpandedRows = { [id]: true };
                    setParentPoolId(poolId);
                } else {
                    newExpandedRows[id] = true;
                }
            }
            // Special case: If clicked row is first row
            const isFirstRow = row.id === planData[0]?.id;

            // if (isFirstRow) {
            //     setSelectedRow(getIdPerPlan(planData[0]));       // Always first row selected
            //     handlePlanFilter(planData[0]);          // Always send first row data
            //     setParentPoolId(planData[0]?.parent_pool_id);
            // } else {
            //     setSelectedRow(getIdPerPlan(row));
            //     handlePlanFilter(row);
            // }

            return newExpandedRows;
        });
    };

    const getAccountType = (data) => {
        if (data?.icon) {
            switch (data.icon) {
                case "CustomPlanIcon":
                    return "custom_plan";
                case "orgPoolIcon":
                    return "sub_pool";
                case "starlinkPlanIcon":
                    return "standard_plan";
                default:
                    return "";
            }
        } else if (data?.account_type) {
            return data.account_type === "pooled" ? "pooled_account" : "standard_account";
        }
    }

    const getAccountId = (data) => {

        if (data?.account_type == 'pooled' || data?.account_type == 'standard' || data?.icon === 'starlinkPlanIcon') {
            return data?.account_number;
        }
        return data?.id;
    }

    const getAccountIds = (data) => {
        if (data?.account_type == 'pooled' || data?.account_type == 'standard') {
            return data?.account_number;
        }
        return data?.id;
    }

    const getIdPerPlan = (row) => {
        if (row?.account_type == 'standard') {
            return row.account_number
        } else {
            return row.id;
        }
    }

    const handlePlanFilter = (row) => {
        setSelectedRow(getIdPerPlan(row));
        setPlanFilter({ plan_id: getAccountIds(row), type: getAccountType(row), account_number: getAccountId(row), name: (row?.account_name || row?.custom_plan_name || row?.pool_name || row?.plan_name || '') })
    }

    const handleOpen = (title: string, row) => {
        setTitle(title);
        setOpen(true);
        handleRowClick(row);
    };

    const renderRow = (row, level = 0) => (
        <React.Fragment key={row.id}>
            <TableRow>
                <TableCell onClick={() => handlePlanFilter(row)} style={{ cursor: 'pointer', paddingLeft: `${level * 20}px`, whiteSpace: "nowrap", display: "flex", alignItems: "center", backgroundColor: selectedRow == getIdPerPlan(row) ? "rgb(83, 225, 174)" : "transparent" }}>
                    {row.children?.length > 0 && row?.children[0] !== null && (
                        <IconButton size="small" style={{ paddingTop: "0px", paddingBottom: "0px" }} onClick={(event) => {
                            event.stopPropagation();
                            handleExpandClick(getIdPerPlan(row), row?.parent_pool_id, row)
                        }}>
                            {expandedRows[getIdPerPlan(row)] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    )}
                    <Grid style={{ maxWidth: '225px', whiteSpace: 'nowrap', overflowX: 'hidden', textOverflow: 'ellipsis', marginLeft: row.children?.length > 0 && row?.children[0] !== null ? '0px' : '15px' }}>
                        {row?.icon ? <img className="icon-cursor" style={{ paddingRight: "10px" }} src={row?.icon === "CustomPlanIcon" ? customPlanIcon : row?.icon === "orgPoolIcon" ? orgPoolIcon : starlinkPlanIcon} /> : null}
                        <Tooltip title={row?.account_type ? row?.account_type.charAt(0).toUpperCase() + row?.account_type.slice(1).toLowerCase() : ""}>
                            <span style={{ color: "blue", cursor: 'pointer', maxWidth: '200px', whiteSpace: 'nowrap', overflowX: 'hidden', textOverflow: 'ellipsis' }}>{row?.account_type ? row?.account_type.charAt(0).toUpperCase() + row?.account_type.slice(1).toLowerCase() + " | " : ""}</span>
                        </Tooltip>
                        <Tooltip title={row?.account_name || row?.custom_plan_name || row?.pool_name || row?.plan_name || ''}>
                            <span style={{ color: "blue", cursor: 'pointer', maxWidth: '200px', whiteSpace: 'nowrap', overflowX: 'hidden', textOverflow: 'ellipsis' }}>{row?.account_name || row?.custom_plan_name || row?.pool_name || row?.plan_name || ''}</span>
                        </Tooltip>
                    </Grid>
                </TableCell>
                <TableCell align="center"  style={{ color: "blue", cursor: 'pointer', backgroundColor: selectedRow == getIdPerPlan(row) ? "rgb(83, 225, 174)" : "transparent" }}>{row?.organizations?.length ?? 0}</TableCell>
                <TableCell align="center" onClick={() => { if(isAdmin) { handleOpen("Service Lines", row)}}} style={{ color: "blue", cursor: 'pointer', backgroundColor: selectedRow == getIdPerPlan(row) ? "rgb(83, 225, 174)" : "transparent" }}>{ row?.total_service_lines || row?.direct_service_lines ? expandedRows[getIdPerPlan(row)] ? row?.direct_service_lines : row.total_service_lines : row?.service_lines ? row?.service_lines : 0 }</TableCell>
                {/* <TableCell align="center" style={{backgroundColor: selectedRow == getIdPerPlan(row) ? "rgb(83, 225, 174)" : "transparent"}}>{row?.unit == 'tb' ? row?.size * 1000 : row?.size}</TableCell>
                <TableCell align="center" style={{backgroundColor: selectedRow == getIdPerPlan(row) ? "rgb(83, 225, 174)" : "transparent"}}>{row.total_usage?.toFixed(2)}</TableCell> */}
                <TableCell align="center" 
                style={{ backgroundColor: selectedRow == getIdPerPlan(row) ? "rgb(83, 225, 174)" : "transparent" }}>
                    <Tooltip classes={{ tooltip: 'starlink--tooltip' }}
                        title={
                            <Grid>
                                <Table size="small" className="starlink--tooltip">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell classes={{ root: 'starlink--tooltip--value_title' }}>
                                                Usage
                                            </TableCell>
                                            <TableCell>
                                                {row?.total_usage?.toFixed(2) ?? 0} GB
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell classes={{ root: 'starlink--tooltip--value_title' }}>
                                                Plan Size
                                            </TableCell>
                                            <TableCell>
                                                {row?.size && row?.unit === "tb" ? row?.size * 1000 : row?.size} GB
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell classes={{ root: 'starlink--tooltip--value_title' }}>
                                                Total Size
                                            </TableCell>
                                            <TableCell>
                                                {row?.service_lines ? row?.size && row?.unit === "tb" ? row?.size * row?.service_lines * 1000 : row?.size * row?.service_lines : row?.size && row?.unit === "tb" ? row?.size * 1000 : row?.size || ''} GB                                                                         </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Grid>
                        }
                  placement="bottom">
                        <div style={{ display: "flex", justifyContent: "center", fontFamily: "monospace" }}>
                            <span style={{ textAlign: "right", minWidth: "60px" }}>{row?.total_usage?.toFixed(2) ?? 0}</span>
                            {/* <span style={{ margin: "0 4px" }}>/</span>
                            <span style={{ textAlign: "left", minWidth: "60px" }}>{
                                row?.size && row?.unit === "tb"
                                    ? !row?.account_type && row?.service_lines !== 0
                                        ?  row?.size * 1000
                                        : row?.size * 1000
                                    : row?.size
                                        ? !row?.account_type && row?.service_lines !== 0
                                            ? row?.size 
                                            : row?.size
                                        : 0}</span> */}
                        </div>
                    </Tooltip>
                </TableCell>
            </TableRow>
            {expandedRows[getIdPerPlan(row)] && row?.children?.length > 0 && (
                row?.children?.map((child) => renderRow(child, level + 1))
            )}
        </React.Fragment>
    );

    useEffect(() => {
        if (!_.isEmpty(serviceLinePlans)) {
            setServicePlansLocal(serviceLinePlans)
        } else {
            setServicePlansLocal([])
        }
    }, [serviceLinePlans])

    const extractPlanPoolOptions = (data, options: any = [], level = 0) => {
        data?.forEach((item: any) => {
            if (item.account_type !== 'standard' && item.icon !== "starlinkPlanIcon") {
                if (item.pool_name) {
                    options.push({
                        value: item.uid,
                        val: item.custom_plan_id,
                        label: item.pool_name,
                        type: "Pool", level,
                        sl: item.service_lines,
                        size: item?.unit === "tb" ? item?.size * 1000 : item?.size
                    });
                } else if (item.custom_plan_name || item.plan_name) {
                    options.push({
                        val: item.id,
                        value: item.uid,
                        label: item.custom_plan_name || item.plan_name,
                        type: "Plan",
                        level,
                        sl: item.service_lines,
                        size: item?.unit === "tb" ? item?.size * 1000 : item?.size
                    });
                } else if (item.account_name) {
                    options.push({
                        value: item.uid, val: item.uid, label: item.account_name, type: "Main Pool", level, sl: item.service_lines,
                        size: item?.unit === "tb" ? item?.size * 1000 : item?.size
                    });
                }

                if (item.children?.length) {
                    extractPlanPoolOptions(item.children, options, level + 1);
                }
            }
        });

        return options;
    };

    useMemo(() => {
        if (!_.isEmpty(planData)) {
            setOptions(extractPlanPoolOptions(planData))
        }
    }, [planData]);


    const handleRowClick = (row) => {
        const selectedObj = options.find(option => option.value === row?.uid);
        let params = {
            dp_id: selectedOu?.id,
            custom_plan_id: selectedObj?.type && selectedObj?.type === 'Main Pool' ? "" : selectedObj?.val ? selectedObj.val : "",
            org_filter: "",
            search: searchValue,
            account_number: row?.account_number ?? '',
            plan_type:  selectedObj?.icon === "starlinkPlanIcon" ? "standard" : "pooled",
            product_reference_id: selectedObj?.type && selectedObj?.type === 'Main Pool' ? "" : selectedObj?.val ? selectedObj.val : "",
        }
        getServiceLinePerPlan(params);
        setSelectedPlan({name: (row?.account_name || row?.custom_plan_name || row?.pool_name || row?.plan_name || ''), row: row});
    };

    useEffect(() => {
        let params = {
            dp_id: selectedOu?.id,
            custom_plan_id:  selectedPlan?.row?.custom_plan_id ?? '',
            org_filter: "",
            search: searchValue,
            account_number: selectedPlan?.row?.account_number ?? ''
        }
        getServiceLinePerPlan(params)
    }, [searchValue])

    return (
        <div>
            <TableContainer component={Paper} className="starlink--table_container strMap-table" style={{ height: expand.isCardExpanded ? "calc(100vh - 372px)" : 'calc(-301px + 100vh)', overflow: 'auto', marginTop: '8px'}}>
                <Table stickyHeader size="small" aria-label="plan-hierarchy-table">
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <span className="font-wt-900" >Plan</span>
                            </TableCell>
                            <TableCell>
                                <span className="font-wt-900">Org</span>
                            </TableCell>
                            <TableCell style={{width: '2%'}}>
                                <span className="font-wt-900">Service Lines</span>
                            </TableCell>
                            <TableCell style={{ width: '2%' }}>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", fontFamily: "monospace" }}>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <span style={{ textAlign: "right", minWidth: "60px" }}>Usage(GB)</span>
                                        {/* <span style={{ margin: "0 4px" }}>/</span>
                                        <span style={{ textAlign: "left", minWidth: "60px" }}>Size</span> */}
                                    </div>
                                    {/* <div>(GB)</div> */}
                                </div>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {planData?.length > 0 ? (
                            planData?.map((row) => renderRow(row))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={4} align="center">
                                    No Plans available.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {open && <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth className="menuScroll plan-usage-hierarchy-popup-sl">
                <DialogTitle className='delete-content-filter-title'>
                    {title}
                    <IconButton onClick={() => setOpen(false)} sx={{ position: "absolute", right: 8, top: 8 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent className="dialog-list-content-filter-dialog-content">
                    <Grid className="middleTable" >
                        <Grid container className="strPlans-senderGridTop">
                            <Grid item className="strPlans-PlanIcon-grid">
                                <div className="strPlans-PlanIconMiddle" ></div>
                                <Typography className="strPlans-senderTypo">{selectedPlan?.name}</Typography>
                            </Grid>
                        </Grid>
                        <div className={`strPlans-pb10hierarchy strPlan-tableHierarchy-Height strPlans-pb10 electedMiddle`}>
                            <>
                                <Grid container spacing={1} className="configTable">
                                    <Grid item xs={1.5} className="configuration-form-build">
                                        <img className="icon-cursor strPlans-pd-r-10" src={planFilterButton} />
                                    </Grid>
                                    <Grid item xs={10.5} className="usage-search-border-color">
                                        <Box className="strPlans-searchbarBox">
                                            <TextField
                                                id="outlined-basic"
                                                variant="outlined"
                                                placeholder="Filter Search"
                                                autoComplete="off"
                                                size="small"
                                                value={searchValue}
                                                onChange={(e) => setSearchValue(e.target.value)}
                                                onKeyDown={(event) => { setSearchValue(searchValue) }}
                                                InputLabelProps={{ className: "serachLabel1" }}
                                                InputProps={{
                                                    className: "strPlans-searchbarInputs",
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            {!searchValue && <SearchIcon
                                                                className="searchbarIconsPosition" onClick={() => { setSearchValue(searchValue) }}
                                                            />}
                                                            {searchValue && <CloseIcon
                                                                className="searchbarIconsPosition"
                                                                onClick={() => { setSearchValue("") }}
                                                            />}
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                                <div className="service-lines-container">
                                    <div className="service-lines-card">
                                        <div className="label">Total Service Lines</div>
                                        <div className={"highlight"}>{servicePlansLocal?.[0]?.total_service_lines || 0}</div>
                                    </div>
                                    <div className="service-lines-card">
                                        <div className="label">Total Organizations</div>
                                        <div className={"highlight"}>{servicePlansLocal?.[0]?.total_organizations || 0}</div>
                                    </div>
                                </div>
                                <TableContainer component={Paper} className="starlink--table_container strMap-table strPlan-tableHeight" >
                                    <Table stickyHeader size="small" aria-label="plan-hierarchy-table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell><span className="font-wt-900">Service Line
                                                    <Switch size="small"
                                                        checked={switchServiceLineToggle}
                                                        onChange={(e) => { setSwitchServiceLineToggle(!switchServiceLineToggle) }}
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                    /></span>
                                                </TableCell>
                                                <TableCell><span className="font-wt-900">Organization</span></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody className="strPlan-sl-table">
                                            {servicePlansLocal?.length > 0 ? (
                                                servicePlansLocal?.map((row: any) => (
                                                    <TableRow key={row.id}>
                                                        <TableCell className="star-plans-usage-hierarchy">{ switchServiceLineToggle ? row?.id : row?.service_lines}</TableCell>
                                                        <TableCell>{row.organization_name}</TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={4} align="center">
                                                        No service lines available.
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </>
                        </div>
                    </Grid>
                </DialogContent>
            </Dialog>}
        </div>
    )
}

const mapStateToProps = (state) => ({
    selectedOu: state.authReducer.selectedOu,
    starlinkPlanUsageHierarchy: state.starlinkReports.starlinkPlanUsageHierarchy,
    serviceLinePlans: state.starlinkPooled.serviceLinePlans,
});

export default withRouter(connect(mapStateToProps, {
    getServiceLinePerPlan
})(PlanHeirarchy));